import type { AppConfig } from '@/api/types';

/** Whether the API can deliver on WhatsApp now. Older APIs send no channel list and always offered it. */
export const offersWhatsApp = (config: AppConfig | null | undefined): boolean =>
  config?.messagingChannels ? config.messagingChannels.includes('whatsapp') : true;

/** Daily WhatsApp reminders are switched off for everyone until the API says otherwise. */
export const offersWhatsAppReminders = (config: AppConfig | null | undefined): boolean =>
  Boolean(config?.whatsappRemindersEnabled);
